import React from 'react';

export default class Page9 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToDirectPeople');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Look for opportunities to
                                                practise
                                            </div>
                                            <p>Think about opportunities in your current work, or beyond, where
                                                you can practise engaging and
                                                motivating others to achieve aims and objectives. Think about
                                                how to do this and what the results
                                                might be. </p>
                                            <div className="border_subtitle">Write a development plan</div>
                                            <p>Make 'engaging others to deliver organisational goals' a personal
                                                objective and make it a part of
                                                your own development plan. Make sure you give yourself clear
                                                objectives and actions to help you
                                                to progress and make a real improvement. </p>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>Further Information
                                            </div>

                                            <p>If you found this tool useful then you are likely to find the
                                                following tools both insightful and relevant: </p>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToEngageOthersToDeliver')}>How
                                                        to engage others to deliver </div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToBeAssertive')}>How
                                                        to be assertive </div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToInfluenceOthers')}>How
                                                        to influence others</div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToCreateTeamIdentity')}>How
                                                        to create team identity </div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToGainBuyInAndCommitment')}>How
                                                        to gain buy-in and commitment </div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToMaintainMomentum')}>How
                                                        to maintain momentum </div></li>
                                                    <li style={{paddingBottom: '0px !important'}}><div
                                                        className="link_color thought button-link-redirect"
                                                        onClick={this._savePageStatus('HowToWinAndManageResources')}>How
                                                        to win and manage resources. </div></li>

                                                </ul>
                                            </div>
                                            <br/>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content"> Asch, S. (1951).
                                                    Effects of group pressure upon the modification and
                                                    distortion of judgement. In H. Guetzkow (ed.) <strong>Groups,
                                                        leadership and men.</strong> Pittsburgh, PA:
                                                    Carnegie Press.</p></li>
                                                <li><p className="further_info_content">Cialdini, R. et al
                                                    (1975). Reciprocal concessions procedure for inducing
                                                    compliance: The door-in-the-face technique. <strong>Journal
                                                        of Personality and Social Psychology</strong>, 31,
                                                    206-215.</p></li>
                                                <li><p className="further_info_content">Sale, N. Rose,
                                                    P. &amp; Page N. (2004). <strong>Effective Management of
                                                        Global Diversity Research Panel.</strong> Pearn
                                                    Kandola. </p></li>
                                                <li><p className="further_info_content">The Gallup
                                                    Organisation, (2004). <a className="link_color thought"
                                                                             href="http://www.gallup.com/"
                                                                             style={{textDecoration: 'none'}}>www.gallup.com </a>
                                                </p></li>
                                                <li><p className="further_info_content">Robinson, D.
                                                    Perryman, S. &amp; Hayday, S. (2004). <strong>The
                                                        Drivers of Employee Engagement</strong>, Institute
                                                    for Employment Studies. </p></li>
                                                <li><p className="further_info_content">Harter, J., Schmidt,
                                                    F. &amp; Hayes, T. (2002). Business unit relationship
                                                    between. employee satisfaction, employee engagement and
                                                    business outcomes: A meta analysis. <strong>Journal of
                                                        Applied Psychology</strong>, 87,
                                                    268-279.</p></li>

                                            </ol>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page8')}
                                                     className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Thought')}
                                                    className="button-next-previous-done thought">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}